import IPathModel from "Models/PathModel";
import NotificationPaths from "./NotificationPaths";
import Notification from "../Pages/Notification/Notification";
import NotificationInfo from "../Pages/Notification/NotificationInfo";

const NotificationRoutes: IPathModel[] = [
  {
    path: NotificationPaths.NotificationMain,
    element: Notification,
  },
  {
    path: NotificationPaths.NotificationInfo,
    element: NotificationInfo,
    params: ["id"],
  },
];

export default NotificationRoutes;
